import { DefaultTheme } from "styled-components";

const STANDARD_BORDER = "rgba(0, 0, 0, 0.1)";

export const LightTheme: DefaultTheme = {
    ROOT_BACKGROUND: {
        FIRST: "#f8fafc",
        LAST: "#cbd5e1"
    },
    ROOT_BORDER: STANDARD_BORDER,

    HEADER: {
        BLOG_NAME: "#1e293b",
        THEME_ICON: "#85a4ff",
        BACKGROUND: "rgba(255, 255, 255, 0.7)",
    },

    MENU: {
        SUBTITLE_COLOR: "#64748b",
        ITEM_COLOR: "#475569",
        HOVER: {
            BACKGROUND: "#f1f5f9",
            FONT_COLOR: "#2563eb"
        }
    },

    BOX_BACKGROUND: "#ffffff",
    BOX_SHADOW: {
        FIRST: "rgba(0, 0, 0, 0.05)",
        LAST: "rgba(0, 0, 0, 0.03)"
    },
    BOX_BORDER: "rgba(0, 0, 0, 0.03)",

    CONTENT: {
            BACKGROUND: "#ffffff",
            BORDER: "rgba(0, 0, 0, 0.03)",
            SHADOW: "rgba(0, 0, 0, 0.05)",
            HOVER: {
                SHADOW: "rgba(0, 0, 0, 0.1)"
            },
            TITLE_COLOR: "#1e293b",
            SUMMARY_COLOR: "#64748b",
            MATCHED: {
                BACKGROUND: "rgba(255, 230, 0, 0.3)",
                FONT_COLOR: "#0051ff"
            },
            UPPER_BOTTOM_BORDER: "rgba(0, 0, 0, 0.1)"
    },

    ABOUT_ME: {
        LI: "#3b82f6",
        FONT_COLOR: "#475569",
        HOVER: {
            FONT_COLOR: "#2563eb"
        }
    },

    IMG_CONTAINER: {
        BORDER: "#000",
        BRIGHTNESS: "brightness(0.7)"
    },

    BTN_ENTER: {
        FONT_COLOR: "#ffffff",
        BORDER: STANDARD_BORDER,
        HOVER: {
            BACKGROUND: {
                FIRST: "#1390fe",
                LAST:  "#006aff"
            },
            SHADOW: "rgba(0, 0, 0, 0.5)"
        }
    },

    BTN_ADD_DELETE: {
        FONT_COLOR: "#ffffff",
        BORDER: STANDARD_BORDER,
        HOVER: {
            BACKGROUND: {
                FIRST: "#ef4444",
                LAST: "#ff422d"
            },
            SHADOW: "rgba(0, 0, 0, 0.5)"
        }
    },

    TAGS: {
        NORMAL: {
            BACKGROUND: "#f1f5f9",
            FONT_COLOR: "#475569",
            BORDER: "transparent"
        },

        SELECTED: {
            BACKGROUND: "#3b82f6",
            FONT_COLOR: "#ffffff",
            BORDER: "#2563eb"
        },

        SEARCHED: {
            BACKGROUND: "#66f96b",
            FONT_COLOR: "#404840",
            BORDER: "#5ad55e"
        },

        HOVER: {
            BACKGROUND: {
                NORMAL: "#e2e8f0",
                SELECTED: "#2563eb",
                SEARCHED: "#6adf6e"
            },
            SHADOW: STANDARD_BORDER
        }
    },

    DATE_TAG: {
        FONT_COLOR: "#ffffff",
        BACKGROUND: {
            FIRST: "#ff5555",
            LAST: "#ff7171"
        },
        BORDER: STANDARD_BORDER
    },

    NONE_TAG: {
        FONT_COLOR: "#000000",
        BACKGROUND: "transparent",
        BORDER: STANDARD_BORDER
    },

    SEARCH: {
        BACKGROUND: "rgba(255, 255, 255, 0.9)",
        BORDER: STANDARD_BORDER,
        SHADOW: "rgba(0, 0, 0, 0.1)",
        FOCUS: {
            BORDER: "#3b82f6",
            SHADOW: "rgba(59, 130, 246, 0.5)"
        }
    },

    MARKDOWN: {
        TABLE: {
            BORDER: "#a39485",
            SHADOW: "rgba(0, 0, 0, 0.25)"
        },

        THEAD: {
            FONT_COLOR: "#ffffff",
            BACKGROUND: "#73685d"
        },

        TD: {
            BORDER: STANDARD_BORDER,
            BACKGROUND: "#ffffff"
        },

        BLOCKQUOTE: {
            BACKGROUND: "#ffffff",
            FONT_COLOR: "#666",
            SHADOW: "#ccc"  
        },

        CODE: {
            SHADOW: "rgba(0, 0, 0, 0.25)"
        }
    },

    PAGE_BTN: {
        BORDER: STANDARD_BORDER,
        FONT_COLOR: "#475569",
        BACKGROUND: {
            CURRENT: "rgba(0, 0, 0, 0.1)",
            NOT_CURRENT: "#fff"
        },
        HOVER: {
            BACKGROUND: "rgba(0, 0, 0, 0.4)",
            FONT_COLOR: "#fff"
        }
    },

    MAGIC_TOOL: {
        BACKGROUND: "#ff0000",
        FONT_COLOR: "#ffffff",
    },

    EACH_MAGIC_TOOL: {
        BACKGROUND: "#000000",
        FONT_COLOR: "#ffffff",
        ACTIVATED: {
            BACKGROUND: "#0051ff",
            FONT_COLOR: "#ffffff"
        }
    }
}

export const DarkTheme: DefaultTheme = {
    ROOT_BACKGROUND: {
        FIRST: "#2a2f34",
        LAST: "#1e2125"
    },
    ROOT_BORDER: STANDARD_BORDER,
    HEADER: {
        BLOG_NAME: "#fff",
        THEME_ICON: "#fbbf24",
        BACKGROUND: "#42474cd7",
    },

    MENU: {
        SUBTITLE_COLOR: "#e0e0e0",  
        ITEM_COLOR: "#f2f2f2",
        HOVER: {
            BACKGROUND: "#393422",
            FONT_COLOR: "#ffe643"
        }
    },

    BOX_BACKGROUND: "#51555f",
    BOX_SHADOW: {
        FIRST: "rgba(215, 215, 215, 0.49)",
        LAST: "rgba(215, 215, 215, 0.56)"
    },
    BOX_BORDER: "rgba(0, 0, 0, 0.03)",

    CONTENT: {
            BACKGROUND: "#51555f",
            BORDER: "rgba(0, 0, 0, 0.03)",
            SHADOW: "rgba(215, 215, 215, 0.56)",
            HOVER: {
                SHADOW: "rgba(215, 215, 215, 0.56)"
            },
            TITLE_COLOR: "#fff",
            SUMMARY_COLOR: "#c8cfd8",
            MATCHED: {
                BACKGROUND: "rgba(255, 204, 20, 0.98)",
                FONT_COLOR: "#ff0000"
            },
            UPPER_BOTTOM_BORDER: "#fff"
    },

    ABOUT_ME: {
        LI: "#f6da3b",
        FONT_COLOR: "#fff",
        HOVER: {
            FONT_COLOR: "#fce24c"
        }
    },

    IMG_CONTAINER: {
        BORDER: "#fff",
        BRIGHTNESS: "brightness(1.2)"
    },

    BTN_ENTER: {
        FONT_COLOR: "#ffffff",
        BORDER: STANDARD_BORDER,
        HOVER: {
            BACKGROUND: {
                FIRST: "#1390fe",
                LAST:  "#006aff"
            },
            SHADOW: "rgba(0, 0, 0, 0.5)"
        }
    },

    BTN_ADD_DELETE: {
        FONT_COLOR: "#ffffff",
        BORDER: STANDARD_BORDER,
        HOVER: {
            BACKGROUND: {
                FIRST: "#ef4444",
                LAST: "#ff422d"
            },
            SHADOW: "rgba(0, 0, 0, 0.5)"
        }
    },

    TAGS: {
        NORMAL: {
            BACKGROUND: "#f1f5f94d",
            FONT_COLOR: "#fbfbfb",
            BORDER: "transparent"
        },

        SELECTED: {
            BACKGROUND: "#3b82f6",
            FONT_COLOR: "#ffffff",
            BORDER: "#2563eb"
        },

        SEARCHED: {
            BACKGROUND: "#66f96b",
            FONT_COLOR: "#404840",
            BORDER: "#5ad55e"
        },

        HOVER: {
            BACKGROUND: {
                NORMAL: "#d9bd5a",
                SELECTED: "#7298ea",
                SEARCHED: "#a6f9a8"
            },
            SHADOW: "#ffffffd6"
        }
    },

    DATE_TAG: {
        FONT_COLOR: "#ffffff",
        BACKGROUND: {
            FIRST: "#8122ee",
            LAST: "#ad64ff"
        },
        BORDER: "transparent"
    },

    NONE_TAG: {
        FONT_COLOR: "#ffffff",
        BACKGROUND: "transparent",
        BORDER: "#ffffffd6"
    },

    SEARCH: {
        BACKGROUND: "rgba(255, 255, 255, 0.4)",
        BORDER: STANDARD_BORDER,
        SHADOW: "rgba(0, 0, 0, 0.1)",
        FOCUS: {
            BORDER: "#3b82f6",
            SHADOW: "rgba(59, 130, 246, 0.5)"
        }
    },

    MARKDOWN: {
        TABLE: {
            BORDER: "#a39485",
            SHADOW: "rgba(0, 0, 0, 0.25)"
        },

        THEAD: {
            FONT_COLOR: "#ffffff",
            BACKGROUND: "#86715c"
        },

        TD: {
            BORDER: STANDARD_BORDER,
            BACKGROUND: "#ffffff74"
        },

        BLOCKQUOTE: {
            BACKGROUND: "#ffffff68",
            FONT_COLOR: "#fff",
            SHADOW: "#cccccc3c"  
        },

        CODE: {
            SHADOW: "rgba(0, 0, 0, 0.25)"
        }
    },
    PAGE_BTN: {
        BORDER: "#fff",
        FONT_COLOR: "#f1f1f1",
        BACKGROUND: {
            CURRENT: "#ffffff6e",
            NOT_CURRENT: "rgba(56, 56, 56, 0)"
        },
        HOVER: {
            BACKGROUND: "rgba(129, 129, 129, 0.84)",
            FONT_COLOR: "#fff"
        }
    },

    MAGIC_TOOL: {
        BACKGROUND: "#ff0000",
        FONT_COLOR: "#ffffff",
    },

    EACH_MAGIC_TOOL: {
        BACKGROUND: "#ffffff",
        FONT_COLOR: "#000000",
        ACTIVATED: {
            BACKGROUND: "#0051ff",
            FONT_COLOR: "#ffffff"
        }
    }
}